// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c80b40d0","453":"ba22a777","732":"0b6f064b","977":"badd2196"}[chunkId] + ".chunk.js";
};